<template>
   <section>
    <div class="container">
        <CommonBreadcrumb class="my-3"/>
    </div>
    <header class="px-0 container-fluid">
        <div class="main_banner_container ">
            <picture>

                <source media="(min-width: 768px)" width="1920" height="600" type="image/png" srcset="~/assets/evertreen/bottom.png">

                <source width="800" height="100vh" type="image/png" srcset="~/assets/evertreen/bottom_mob.png">
                <img width="1920" height="540" type="image/png" srcset="~/assets/evertreen/bottom.png"
                    alt="green and sustainable gift banner" />
            </picture>

            <div class="main_banner_content-container text-center">
                <p class="banner_heading">GIVING BACK TO OUR</p>
                <p class="banner_subheading">Planet</p>
            </div>
        </div>
    </header>
    <section class="container mt-4 mt-md-5 green_imprint">
        <h1 class="green_imprint_heading font-active">The ‘Friendly’ <span>Green Imprint</span></h1>
        <p class="green_imprint_subheading">FOR A FRIENDLIER <span>PLANET</span></p>
        <div class="text-center green_imprint_container">
            <div class="green_imprint_text">
                <p>
                    At the heart of our brand lies a deep commitment to sustainability, a value that has guided us since
                    our
                    inception. At Friendly Diamonds, our mission is to be conscious of the carbon footprints of what we
                    do
                    for the industry and give back to society in every possible way. 
                </p>
                <p>
                    To sustain this purpose, we are introducing a new initiative powered by Evertreen, that helps us in
                    reinforcing our dedication to the ecosystem. For every purchase you make on the Friendly Diamonds’
                    website, we sow the seeds of new trees in several regions of Africa – and together, we create a
                    flourishing forest!
                </p>
                <p>

                    Friendly Diamonds sincerely welcomes you to contribute towards this initiative by planting your own
                    trees through conscious lab diamond purchases.
                </p>
            </div>

            <!-- <NuxtLink class="button green_imprint-btn" :to="localePath({ name: '' })">ADD TO OUR FRIENDLY FOREST
            </NuxtLink> -->
            
            <a rel="nofollow noopener" target="_blank" href="https://evertreen.com/company/FriendlyDiamonds" class="button green_imprint-btn radious_eight">ADD TO OUR FRIENDLY FOREST</a>

        </div>

        <div class="green_imprint_video_container">
            <div class="video_card_container">
                <div class="video_card video_card1">
                    <h4 class="font-active" id="countup1">856.50</h4>
                    <p>Tonnes of co2 <br /> being offset</p>
                </div>

                <div class="video_card video_card2">
                    <h4 class="font-active" id="countup2">2855</h4>
                    <p>Trees <br /> planted</p>
                </div>

                <div class="video_card video_card3">
                    <h4 class="font-active" id="countup3">356.88</h4>
                    <p>WORKING HOURS <br /> CREATED</p>
                </div>
            </div>
            <video  @contextmenu.prevent="" controlsList="nodownload" ref="video"  width="100%" height="1080"
                autoplay loop muted playsinline>
                <source src="https://assets.friendlydiamonds.com/fdl/static-video/earth.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>
           
        </div>

    </section>
    <section class="planet-journey container mt-4 mt-md-5">
        <h2 class="font-active">The Beginning of Our Planting Journey</h2>
        <div class="youtube-frame_container">
            <iframe src="https://www.youtube.com/embed/GPSr9QrnFPw?si=8LWceTO0shaTQ0w8" frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
            </iframe>
        </div>
    </section>
</section> 

</template>


<script setup>
import { CountUp } from 'countup.js';


onMounted(()=>{
     new CountUp("countup1", 856.50,{ enableScrollSpy: true,decimalPlaces:2,scrollSpyOnce:true });
     new CountUp("countup2", 2855,{ enableScrollSpy: true ,scrollSpyOnce:true});
     new CountUp("countup3", 356.88,{ enableScrollSpy: true,decimalPlaces:2 ,scrollSpyOnce:true});
})


useFetchMeta( useNuxtApp(), useRuntimeConfig() );
// const localePath = useLocalePath()
// const { $country } = useNuxtApp()
</script>

<style scoped>
.main_banner_container {
    position: relative;
    animation: fadeIn 1s ease-in-out forwards;
    overflow: hidden;

}

.main_banner_container::after {
    content: '';
    display: block;
    width: 100%;  
    height: 100%;  
    background-image: url('../assets/evertreen/top.png');
    background-size: cover;  
    background-position: center center;  
    background-repeat: no-repeat;  
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;  
    animation: fadeInAndMoveup 1.5s ease-in-out forwards;
    animation-delay: .3s;

}



@keyframes fadeIn {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

@keyframes fadeInAndMoveDown {
    from {
        opacity: 0;
        top: 0%;
        left: 50%;
        transform: translate(-50%, 0%);
    }
    to {
        opacity: 1;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -35%);
    }
}

@keyframes fadeInAndMoveup {
    from {
        opacity: 0;
        top: 20px;
    }
    to {
        opacity: 1;
        top: 0;
    }
}

.main_banner_content-container {
    position: absolute;
    /* top: 35%;
    left: 50%;
    transform: translate(-50%, -35%); */
   

    text-align: center;
    text-transform: uppercase;
    animation: fadeInAndMoveDown 1.5s ease-in-out forwards ;
    animation-delay: .3s;
}

/* banner content */
.banner_heading {
    font-size: 16px;
    letter-spacing: 3px;
    color: #405955;
    font-weight: bold;
    margin: 0;
}

.banner_subheading {
    font-size: 65px;
    letter-spacing: 8px;
    color: #ffffff;
    font-weight: bold;
    line-height: 1.1;
}

/* green_imprint */

.green_imprint_heading {
    color: #353535;
    text-align: center;

    /* desktop */
    font-size: 24px;

}

.green_imprint_heading span {
    color: #405955;
}

.green_imprint_subheading {
    /* desktop */
    font-size: 14px;
    text-align: center;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: #668b84;
    margin: 0;
}


.green_imprint_subheading span {
    color: #405955;
    font-weight: bold;
}



.green_imprint_text {
    /* desktop */
    padding: 12px 0;

}


.green_imprint_text p {
    font-size: 14px;
    line-height: 20px;
    color: #606060;
    font-weight: medium;
}

.green_imprint-btn {
    border: 1px solid #405955;
    padding: 14px 30px;
    font-size: 14px;
    letter-spacing: 1.12px;
    font-weight: bold;
    text-transform: uppercase;
    color: #405955;
    text-align: center;
    display: block;
    max-width: max-content;
    margin: auto;
}

.green_imprint_video_container {
    position: relative;
    margin: 30px 0px;
}

.green_imprint_video_container video {
    /* border-radius: 14px; */
    border-radius: 0px 0px 8px 8px;
}



.video_card_container {
    display: flex;
    flex-direction: row;
    gap: 12px;
    /* justify-content: center; */
    /* align-items: center; */
    width: 100%;
    /* max-width: 500px; */
    
    margin: auto;
    
    

}

@media(max-width:767px) {
    .green_imprint_video_container video {
        height: auto;
        
    }
    
    .video_card_container{
        width: 100%;
        background-color: #000000;
        padding: 12px 12px 0px 12px ;
        border-radius: 8px 8px 0px 0px;
        
    }
}

.video_card {
    backdrop-filter: blur(10px);

    -webkit-backdrop-filter: blur(10px);
    padding: 8px;
    text-align: center;
    border-radius: 4px;
    text-transform: uppercase;
    flex: 1;
    width: 100%;
}



.video_card h4, .video_card .countup {
    color: #ffffff;
    text-align: center;
    font-weight: bold;
    font-size: 22px;
    
}

.video_card p {
    color: #eaeaea;
    text-align: center;
    margin: 0;
    font-size: 10px;
    letter-spacing: 1.5px;
}



.planet-journey h2 {

    text-align: center;
    color: #212529;
    margin: 0;

    font-size: 24px;
    margin-bottom: 16px;

}

.youtube-frame_container iframe {
    width: 100%;
    height: 400px;
}

.video_card1{
    background-color: rgba(42, 104, 133, 0.2);
}

.video_card2{
    background-color: rgba(102, 139, 132, 0.2);

}

.video_card3{
    background-color: rgba(211, 181, 163, 0.25);
}


/* tablets */
@media(min-width:768px) {
    .banner_heading {
        font-size: 20px;
    }

    .green_imprint_heading {
        font-size: 40px;
    }

    .green_imprint_subheading {
        font-size: 20px;
        letter-spacing: 2px;

    }

    .green_imprint_text {
        padding: 32px 0;

    }

    .green_imprint_text p {
        font-size: 16px;
        line-height: 24px;
    }

    .green_imprint-btn {
        padding: 14px 43px;
        letter-spacing: 1.4px;

    }

    .green_imprint_video_container video {
        height: auto;
        border-radius: 8px;
    }

    .planet-journey {
        margin-bottom: 20px;
    }
    
    .planet-journey h2{
        font-size: 40px;

    }

    .video_card_container {
        position: absolute;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        padding: 10px;
    }

    /* .video_card {
        background-color: #d3b5a340;
    } */

   

}

/* desktop */
@media(min-width:1200px) {
    .banner_heading {
        font-size: 20px;
        letter-spacing: 6px;

    }

    .banner_subheading {
        font-size: 80px;
        letter-spacing: 20px;
    }


    .green_imprint_container {

        padding: 0px 150px;
    }

    .video_card_container {
        flex-direction: column;
        gap: 20px;
        height: 100%;
        left: 100%;
        transform: translateX(-100%);
        padding: 20px;
        width: max-content;
    }

    .green_imprint_video_container video {
        height: auto;
    }


    .video_card {
        padding: 20px;
        border-radius: 8px;

    }

    .video_card h4, .video_card .countup {
        font-size: 60px;
        min-width: 200px;

    }

    .video_card p {
        letter-spacing: 2px;
        font-size: 18px;
    }

    .youtube-frame_container iframe {
        height: 600px;
    }
}

/* for video card  */

@media(min-width: 1260px) {
    .video_card_container{
        padding: 25px 20px;
    }
    .green_imprint_video_container video {
        /* height: 700px; */
    }


    .video_card {
        padding: 30px;
    }
}

@media(min-width:1600px){
    .banner_heading {
        font-size: 30px;
        letter-spacing: 6px;

    }

    .banner_subheading {
        font-size: 160px;
        letter-spacing: 30px;
    }
}
</style>